import { fromJS } from 'immutable';
import * as constants from './constants';

//初始化数据
const defaultState = fromJS({
    successRates: {},  //抄表成功率
    breakRanks: {},  //断线排名
    communicationQuality: {},  //通讯质量
    gatewayNormals: {},  //网关异常
    equipmentNormals: {},  //设备异常
    deviceNormals: {},  //单个设备（网关或终端）异常

});

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = defaultState, action) => {
    switch (action.type) {

        case constants.SUCCESS_RATE:
            return state.set('successRates', action.data);

        case constants.BREAK_RANKS:
            return state.set('breakRanks', action.data);

        case constants.COMMUNICATION_QUALITY:
            return state.set('communicationQuality', action.data);

        case constants.GATEWAY_NORMALS:
            return state.set('gatewayNormals', action.data);

        case constants.EQUIPMENT_NORMALS:
            return state.set('equipmentNormals', action.data);

        case constants.DEVICE_NORMALS:
            return state.set('deviceNormals', action.data);


        default:
            return state;
    }
};
